export default __webpack_public_path__ + "static/heels1.inspirations-99dde3187e26f78921d6b3cda7aef4df.jpg";